import {
  DashboardOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  AppleOutlined,
  CreditCardOutlined,
  TrophyOutlined,
  BellOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  QuestionCircleOutlined,
  TranslationOutlined,
  BarChartOutlined,
  RobotOutlined,
  AuditOutlined,
  SettingOutlined,
  SafetyCertificateOutlined,
  GiftOutlined,
  ShopOutlined,
} from "@ant-design/icons";

// Central navigation source of truth for the admin sidebar.
// `section` groups items under Menu.ItemGroup labels.
// `path` drives routing; `enabled: false` marks screens not yet built —
// the route/menu item exists so the architecture is ready to extend,
// but no page UI has been created for it in this phase.
export const navigationItems = [
  {
    key: "dashboard",
    label: "Anasayfa",
    icon: DashboardOutlined,
    path: "/admin",
    section: "ANA",
    enabled: true,
  },
  {
    key: "users",
    label: "Kullanıcılar",
    icon: TeamOutlined,
    path: "/admin/users",
    section: "YÖNETİM",
    enabled: true,
  },
  {
    key: "workouts",
    label: "Antrenmanlar",
    icon: ThunderboltOutlined,
    path: "/admin/workouts",
    section: "YÖNETİM",
    enabled: true,
  },
  {
    key: "nutrition",
    label: "Beslenme",
    icon: AppleOutlined,
    path: "/admin/nutrition",
    section: "YÖNETİM",
    enabled: true,
  },
  {
    key: "subscriptions",
    label: "Abonelikler",
    icon: CreditCardOutlined,
    path: "/admin/subscriptions",
    section: "YÖNETİM",
    enabled: true,
  },
  {
    key: "store",
    label: "MB Shop",
    icon: ShopOutlined,
    path: "/admin/store",
    section: "YÖNETİM",
    enabled: true,
  },
  {
    key: "gamification",
    label: "Oyunlaştırma",
    icon: TrophyOutlined,
    path: "/admin/gamification",
    section: "ETKİLEŞİM",
    enabled: true,
  },
  {
    key: "notifications",
    label: "Bildirimler",
    icon: BellOutlined,
    path: "/admin/notifications",
    section: "ETKİLEŞİM",
    enabled: true,
  },
  {
    key: "support",
    label: "Destek",
    icon: CustomerServiceOutlined,
    path: "/admin/support",
    section: "ETKİLEŞİM",
    enabled: true,
  },
  {
    key: "content",
    label: "İçerik",
    icon: FileTextOutlined,
    path: "/admin/content",
    section: "İÇERİK",
    enabled: true,
  },
  {
    key: "campaigns",
    label: "Kampanyalar",
    icon: GiftOutlined,
    path: "/admin/campaigns",
    section: "İÇERİK",
    enabled: true,
  },
  {
    key: "faq",
    label: "SSS",
    icon: QuestionCircleOutlined,
    path: "/admin/faq",
    section: "İÇERİK",
    enabled: true,
  },
  {
    key: "translations",
    label: "Çeviriler",
    icon: TranslationOutlined,
    path: "/admin/translations",
    section: "İÇERİK",
    enabled: true,
  },
  {
    key: "legal",
    label: "Yasal",
    icon: SafetyCertificateOutlined,
    path: "/admin/legal",
    section: "İÇERİK",
    enabled: true,
  },
  {
    key: "analytics",
    label: "Analitik",
    icon: BarChartOutlined,
    path: "/admin/analytics",
    section: "ANALİTİK",
    enabled: true,
  },
  {
    key: "ai",
    label: "Yapay Zeka",
    icon: RobotOutlined,
    path: "/admin/ai",
    section: "ANALİTİK",
    enabled: true,
  },
  {
    key: "audit-logs",
    label: "Denetim Kayıtları",
    icon: AuditOutlined,
    path: "/admin/audit-logs",
    section: "SİSTEM",
    enabled: true,
  },
  {
    key: "settings",
    label: "Ayarlar",
    icon: SettingOutlined,
    path: "/admin/settings",
    section: "SİSTEM",
    enabled: true,
  },
];

// Ordered list of section labels, controls the group render order.
export const navigationSections = [
  "ANA",
  "YÖNETİM",
  "ETKİLEŞİM",
  "İÇERİK",
  "ANALİTİK",
  "SİSTEM",
];
